import { useState } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { isEmpty } from 'lodash';

export const TaskStatusFilterSelector = ({ item, applyValue }) => {
  const [state, setState] = useState({
    operator: item.value?.operator || null,
    filterValue: item.value?.filterValue || null,
    multipleFilterValue: item.value?.multipleFilterValue || []
  });
  const handleOperatorChange = (event, newValue) => {
    const newState = {
      operator: newValue,
      filterValue: null,
      multipleFilterValue: []
    };
    setState(newState);
    applyValue({ ...item, value: !isEmpty(newValue) ? newState : null });
  };
  const onFilterValueChange = (event, newValue) => {
    const newState = { ...state, filterValue: newValue };
    setState(newState);
    applyValue({ ...item, value: newState });
  };

  const onFilterMultipleValueChange = (event, newValue) => {
    const newState = { ...state, multipleFilterValue: newValue };
    setState(newState);
    applyValue({ ...item, value: newState });
  };

  const tasksStatuses = ['Open', 'Pending'];

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <Autocomplete
        fullWidth
        options={['is', 'is not', 'is any of']}
        value={state?.operator || null}
        onChange={handleOperatorChange}
        renderInput={params => (
          <TextField {...params} variant="standard" label="Operator" placeholder="Operator" fullWidth />
        )}
      />
      {item.value?.operator === 'is any of' ? (
        <Autocomplete
          fullWidth
          multiple
          options={tasksStatuses}
          value={state?.multipleFilterValue || []}
          onChange={onFilterMultipleValueChange}
          renderInput={params => <TextField {...params} variant="standard" label="Status value" placeholder="Status" />}
        />
      ) : (
        <Autocomplete
          fullWidth
          options={tasksStatuses}
          value={state?.filterValue || null}
          onChange={onFilterValueChange}
          renderInput={params => <TextField {...params} variant="standard" label="Value" placeholder="Filter Value" />}
        />
      )}
    </Box>
  );
};
